<template>
	<div>
		<div class="main-header">
			<div class="container">
				<h2 class="main-header-text">Transaction TAC</h2>
			</div>
		</div>
		<!-- eo main header -->
		<div class="main-section mgt-40">
			<div class="container">
				<div class="main-card text-center">
					<img src="/static/img/icons/arrow-down-indicator-red.png" alt="" class="top-indicator" />

					<div class="rate-box otp-box otp">
						<div class="form-card-forms">
							<!-- <h4 class="header">Verification</h4>
							<h4 class="detail">To proceed, please enter your OTP number</h4> -->
							<div class="otp-form">
								<form @submit.prevent="onSubmit" novalidate autocomplete="off">
									<div class="form-group">
										<label for="otp">TAC<span class="text-red">*</span></label>
										<input type="num" class="form-control otp" id="TAC" name="TAC" maxlength="6" minlength="6" style='height:80px'
													 v-only-numeric autocomplete="off" v-model="vModel.TAC"
													 v-validate="'required|min:6|max:6'" :class="{'input': true, 'is-danger': errors.has('TAC') }">
										<div v-show="errors.has('TAC')" class="help is-danger">
											{{ errors.first('TAC') }}
										</div>
									</div>
									<button class="btn main-btn">Submit TAC</button>
									<!-- <div>
											<button class="btn btn-secondary btn-lg" type="submit">Submit TAC</button>
											<button type="button" class="btn btn-primary btn-lg" @click="onResendOtp">Request TAC</button>
											<button type="button" class="btn btn-danger btn-lg" @click="onCancel">Cancel</button>
									</div> -->
								</form>

								<div class="ekycwrappper"></div>
							</div>
						</div>
					</div>
					<div class="rate-option-btn">
						<div class="submit-option maxw-700">
							<div class="left-option">
								<button type="button" class="btn submit-lefticon-btn" @click="onCancel">
									<span class="left-icon">
										<i class="material-icons">chevron_left</i>
									</span>
									<span class="btn-content">Cancel</span>
								</button>
							</div>
							<div class="right-option">
								<p>
									Didn't get the code? <a href="javascript:void(0)" class="resend" @click="onResendOtp">Request TAC</a>
								</p>
							</div>
						</div>
					</div>
				</div>
				<!-- eo main card -->
			</div>
			<!-- eo container -->
		</div>
		<!-- eo main section -->
	</div>
</template>
<script>
	import Base from "../../shared/Base.vue";
	import Action from "../../shared/Action.vue";
	import Mode from "../../shared/Mode.vue";

	import { vueinstance } from "../../main";
	import authservice from "../../services/authservice";
	import commonService from "../../services/common";

	export default {
		name: "transactionotp",
		extends: Base,
		components: {
			Action,
			Mode
		},
		created() {
			this.url.submitnoOTP = "payment/mmoney/submittransaction";
		},
		mounted() {
			this.vModel.TransactionRefNo = commonService.getStorage("transactionRefNo");
			this.vModel.MMPayUserName = commonService.getStorage("mmpayUserName");
		},
		beforeRouteEnter(to, from, next) {
			if (commonService.getStorage("transactionRefNo") != null) {
				next();
			} else {
				next({ path: "/dashboard" });
			}
		},
		data() {
			return {
				TransactionRefNo: "",
				MMPayUserName: "",
				TAC: ""
			};
		},
		methods: {
			onSubmit: function () {
				var self = this;

				if (self.isProcessing) return false;
				self.$validator.validateAll().then(result => {
					if (result && self.beforeSave()) {
						self.isProcessing = true;

						self.$http.post("transaction/ekyctxnweb", self.vModel).then(
							response => {
								if (response.body.PaymentMethod == 2) {
									commonService.setStorage(
										"AuthMode",
										response.body.AuthMode
									);
									if (response.body.AuthMode == "NoAuth") {
										this.vModel = {
											TransactionRefNumber: response.body.TransactionRefNo,
											OTP: null
										};
										this.$http.post(this.url.submitnoOTP, this.vModel).then(
											res => {
												commonService.setStorage("transactionRefNo", "");
												this.isProcessing = false;
												this.$router.push("/transaction/confirmation/" + response.body.TransactionRefNo);
											}
										);
									} else {
										this.$router.push("/transaction/otp");
									}
									/*this.$router.push("/transaction/otp");*/
								}
								else if (response.body.PaymentMethod == 4){
									this.$router.push("/transaction/confirmation/" + self.vModel.TransactionRefNo);
								} else if (response.body.PaymentMethod == 6) {
								var ipay88 = document.querySelector(".ekycwrappper");
								ipay88.innerHTML = response.body.Body;
								var f = ipay88.querySelector("#ePayment");
								f.submit();
								}
								else {
									var fpx = document.querySelector(".ekycwrappper");
									fpx.innerHTML = response.body.Body;
									var f = fpx.querySelector("#bankpaymentform");
									f.submit();
								}
							},
							error => {
								self.isProcessing = false;
							}
						);
					}
				});
			},
			onCancel: function () {
				commonService.removeStorage("transactionRefNo");
				commonService.removeStorage("mmpMobileNumber");
				this.$router.push("/dashboard");
			},
			onResendOtp: function () {
				var self = this;
				self.isProcessing = true;

				self.$http
					.post("transaction/ekyctxnotpresend", {
						TransactionRefNo: this.vModel.TransactionRefNo,
						MMPayUserName: this.vModel.MMPayUserName,
						TAC: ""
					})
					.then(
						response => {
							self.$toastr("success", "TAC Resend Successfully");
							self.isProcessing = false;
						},
						error => {
							self.isProcessing = false;
						}
					);
			}
		}
	};
</script>

